module.exports = __webpack_public_path__ + "static/media/gansu_icon_medium.6b2aee1c.png";